/**
 * Наборы методов для работы с localStorage и sessionStorage
 */
const fakeStorage = {
  get: function () {},
  key: function () {},
  getItem: function () {},
  setItem: function () {},
  removeItem: function () {},
  clear: function () {},
  length: 15,
}
let lStorage, sStorage

try {
  lStorage = getStorageWrapper(localStorage)
  sStorage = getStorageWrapper(sessionStorage)
} catch (e) {
  lStorage = getStorageWrapper(fakeStorage)
  sStorage = getStorageWrapper(fakeStorage)
}

export const LS = lStorage
export const SS = sStorage

/**
 * Возвращает объект-обёртку для работы с переданным хранилищем
 * @param {Object} storage Хранилище
 * @returns {Object} Обёртка для работы с переданным хранилищем
 */
function getStorageWrapper (storage) {
  const wrapper = { storage }
  wrapper.get = getSafelyFromStorage.bind(wrapper)
  wrapper.set = setSafelyInStorage.bind(wrapper)
  wrapper.remove = removeSafelyFromStorage.bind(wrapper)
  return wrapper
}

/**
 * Возвращает значение из хранилища по ключу
 * @param {string} key Ключ
 * @returns {string} Значение из хранилища по ключу
 */
function getSafelyFromStorage (key) {
  let value = null
  /*
   * Если параметр передан, получаем значение из хранилища.
   * В случае, если аргумент не передан он инициируется и передастся дальше как undefined.
   * Это приведет к получению из хранилища значения по ключу 'undefined' в случае вызова без параметров.
   */
  if (arguments.length && this.storage) {
    try {
      value = JSON.parse(this.storage.getItem(key))
    } catch (error) {
      value = this.storage.getItem(key)
    }
  }
  return value
}

/**
 * Сохраняет значение по ключу в переданное хранилище
 * @param {string} key Ключ
 * @param {*} value Значение
 * @param {Function} [onError] Функция обратного вызова при ошибке
 */
function setSafelyInStorage (key, value, onError) {
  if (arguments.length >= 2) {
    try {
      this.storage.setItem(key, JSON.stringify(value))
    } catch (error) {
      _.isFunction(onError) && onError(error)
    }
  }
}

/**
 * Удаляет значение из хранилища по ключу
 * @param {string} key Ключ
 */
function removeSafelyFromStorage (key) {
  if (arguments.length && this.storage) {
    this.storage.removeItem(key)
  }
}
